var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.002 36H14.002V14H26.002V36ZM30.002 36V14H40.002V34C40.002 34.5304 39.7912 35.0391 39.4162 35.4142C39.0411 35.7893 38.5324 36 38.002 36H30.002ZM10.002 36H2.00195C1.47152 36 0.962812 35.7893 0.587739 35.4142C0.212667 35.0391 0.00195313 34.5304 0.00195312 34V14H10.002V36ZM40.002 10H0.00195312V2C0.00195312 1.46957 0.212667 0.960859 0.587739 0.585786C0.962812 0.210714 1.47152 0 2.00195 0H38.002C38.5324 0 39.0411 0.210714 39.4162 0.585786C39.7912 0.960859 40.002 1.46957 40.002 2V10Z",
    fill: "#E3D9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.406d98d8.svg";
export { ForwardRef as ReactComponent };